var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata-content"},[_c('img',{attrs:{"src":require("@/assets/img/empty.svg"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }